export enum AppRoutes {
  LANDING_PAGE = 'landing-page',
  PRICING_MODULE_GROUPS = 'pricing-module-groups',
  PRICING_MODULE_LIBRARY = 'pricing-module-library',
  PRICING_MODULE_GROUP_MANAGEMENT = 'pricing-module-group-management',
  NOT_AUTHORIZED_PAGE = 'not-authorized-page',
}
